import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const LivePlayer = Loadable({
    loader: () => import(/* webpackChunkName: "LivePlayer" */ './modules/livePlayerAsync'),
    loading: () => <div />,
});
